/* External dependencies */
import { composeWithDevTools } from 'redux-devtools-extension';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { applyMiddleware, combineReducers, createStore as createReduxStore } from 'redux';

/* Local dependencies */
import { logInReducer } from './logInModal/reducer';
import { authModalReducer } from './authModal/reducer';
import { authorizationReducer } from './signUp/reducer';
import { emailValidateReducer } from './emailInputModal/reducer';
import { pinCodeValidationReducer } from './pinCodeModal/reducer';
import { createPasswordReducer } from './createPasswordModal/reducer';
import { confirmCodeEpic, confirmPasswordEpic, getSessionEpic, passwordForgotEpic, signInEpic, signOutEpic, signUpEpic } from './epics';
// import getDevices from '../components/devices/getDevices/redux/reducer';

const rootEpic = combineEpics(
  signUpEpic,
  signInEpic,
  signOutEpic,
  getSessionEpic,
  confirmCodeEpic,
  passwordForgotEpic,
  confirmPasswordEpic,
);

const rootReducer = combineReducers({
  logInReducer,
  // getDevices,
  authModalReducer,
  authorizationReducer,
  emailValidateReducer,
  createPasswordReducer,
  pinCodeValidationReducer,
});

const epicMiddleware = createEpicMiddleware();

export const store = createReduxStore(rootReducer, composeWithDevTools(applyMiddleware(epicMiddleware)));

epicMiddleware.run(rootEpic);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
